<template>
  <div>
    <div class="Breadcrumb u-desktopOnly">
      <ul>
        <li class="Breadcrumb__item"><router-link to="/">{{ $t("home") }}</router-link></li>
        <li class="Breadcrumb__item"><router-link to="/terms-and-conditions">{{ $t("termsAndConditions") }}</router-link></li>
        <li class="Breadcrumb__item"><span v-html="$t('imagic')"></span></li>
      </ul>
    </div>

    <div class="PageHeader">
      <h1 class="PageHeader__heading">{{ $t("termsAndConditions") }}</h1>
    </div>
    <div class="HeroImage">
      <div v-if="!this.$route.query.region" class="HeroImage__content">
        <h2 class="HeroImage__content__heading">{{ $t("selectRegion") }}</h2>
        <div class="Selection">
          <router-link class="Selection__item" to="/terms-and-conditions/imagic?region=uk"><span v-html="$t('ukEu')"></span></router-link>
          <router-link class="Selection__item" to="/terms-and-conditions/imagic?region=us"><span v-html="$t('northAmerica')"></span></router-link>
        </div>
      </div>
    </div>
    <div v-if="this.$route.query.region" class="RichTextArea">
      <h2 v-html="$t('imagic')"></h2>

      <div v-if="this.$route.query.region && this.$route.query.region.toLowerCase() == 'uk'" v-html="$t('tcImagicUk')"></div>
      <div v-if="this.$route.query.region && this.$route.query.region.toLowerCase() == 'us'" v-html="$t('tcImagicUs')"></div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TCImagic',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import './../../styles/_variables';

  .HeroImage {
    height: 26em;
    background: url('./../../assets/bg/people-having-fun.jpg');
    background-size: cover;
    background-position: center;
    @media (max-width: 405px) {
      height: 30em;
    }

    @media (min-width: $tabletSmall) {
      height: 26.875em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TermsAndConditions/Imagic.vue